<template>
  <div>
    <v-dialog
      v-model="failureDialog"
      width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline red"
          primary-title
        >
          <v-layout row justify-center>
            <v-icon dark x-large>error_outline</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h3>{{ failureMsg }}</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeFailureDialog"
          >
            {{ $translate("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "FailureDialog",
  props: {
    failureMsg: String
  },
  data() {
    return {
      failureDialog: true
    };
  },
  methods: {
    closeFailureDialog() {
      this.failureDialog = false;
      this.$emit("failure-dialog-closed");
    }
  }
}
</script>